import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { MST4040_R01Dto } from "./Dto_MST4040_R01";
import { MST4040_R01Filter } from "./Store_MST4040_R01";

const baseUrl = `${config.apiUrl}/MST4040_R01`;

export const getMST4040_R01List = async (
	option: string,
	params: Partial<MST4040_R01Filter>,
	listLength: number = 0,
) => {
	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<MST4040_R01Dto[]>>(url, {
		params: {
			...params,
			listLength,
		},
	});
};

export const getMST4040_R01AllCount = async (params: Partial<MST4040_R01Filter>) => {
	const url = `${baseUrl}/allCount`;

	return await getData<ResponseDto<number>>(url, {
		params: {
			...params,
		},
	});
};

export const getMST4040_R01One = async (moldCd: string) => {
	const url = `${baseUrl}/one/${moldCd}`;

	return await getData<ResponseDto<MST4040_R01Dto>>(url);
};

export const createMST4040_R01 = async (data: MST4040_R01Dto) => {
	return await postData<MST4040_R01Dto, ResponseDto<MST4040_R01Dto[]>>(baseUrl, data);
};

export const patchMST4040_R01 = async (data: MST4040_R01Dto) => {
	return await patchData<MST4040_R01Dto, ResponseDto<MST4040_R01Dto[]>>(baseUrl, data);
};

export const deleteMST4040_R01 = async (moldCd: string) => {
	const url = `${baseUrl}/${moldCd}`;

	return await deleteData<ResponseDto<any>>(url);
};

export const downloadExcel_MST4040_R01 = async (
	option: string,
	params: Partial<MST4040_R01Filter>,
	listLength: number = 0,
) => {
	const url = `${baseUrl}/excel/${option}`;

	return await getData<ResponseDto<string>>(url, {
		params: {
			...params,
			listLength,
		},
	});
};
